import { SxProps } from '@mui/material/styles'

/** Wraps long unbroken names inside flex layouts when paired with ancestor `minWidth: 0`. */
export const nameOverflowStyle: SxProps = {
  overflowWrap: 'anywhere',
}
